<template>
    <div class="row m-2 fs-12">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex align-items-center mb-2">
                        <span class="mr-2">Yth.</span>
                        <template v-if="CurrentlyPrintingLetter">
                            <span>
                                {{ TertujuHeader }}
                            </span>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <input v-model="TertujuHeader" type="text" class=" form-control" />
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </div>
                                </div>
                            </validation-provider>
                        </template>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                        <span class="invisible mr-2">Yth.</span>
                        <template v-if="CurrentlyPrintingLetter">
                            <span>
                                {{ TertujuDetail }}
                            </span>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <input v-model="TertujuDetail" type="text" class=" form-control" />
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </div>
                                </div>
                            </validation-provider>
                        </template>
                    </div>
                    <div class="d-flex align-items-center">
                        <span class="invisible mr-2">Yth.</span>
                        <span>di Tempat.</span>
                    </div>
                </div>
                <div class="col-12 mt-4">
                    <p>Mohon pemeriksaan/pengobatan lebih lanjut terhadap:</p>
                </div>
                <div v-if="PasienInformation && Object.keys(PasienInformation).length > 0" class="col-12">
                    <table class="table table-borderless">
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 23%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienName }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 23%">umur</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienAge }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 23%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ ParseJenisKelaminSurat(PasienSex) }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-uppercase pl-0" style="width: 23%">nik</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienNIK }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 15%">pekerjaan</td>
                            <td>

                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span>
                                            {{ IsLainLainSelected ? CustomPekerjaan : SelectedPekerjaan }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <VMultiSelect v-model="SelectedPekerjaan" :options="PekerjaanSurat"
                                                        :show-labels="false" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <template v-if="!CurrentlyPrintingLetter">
                            <tr v-if="IsLainLainSelected">
                                <td></td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <span class="mr-4">:</span>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <input v-model="CustomPekerjaan" type="text" class="form-control" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 23%">alamat</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienAddress }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 23%">anamnesa</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <span class="pasien-anamnesa" v-html="PasienAnamnesa"></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 23%">pemeriksaan fisik</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize" style="width: 23%; padding-left: 35px">1. tinggi badan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienHeight && PasienHeight > 0">{{ PasienHeight }}</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize" style="width: 23%; padding-left: 35px">2. berat badan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienWeight && PasienWeight > 0">{{ PasienWeight }}</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize" style="width: 23%; padding-left: 35px">3. sistol</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienSystole && PasienSystole > 0">{{ PasienSystole }}</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize" style="width: 23%; padding-left: 35px">4. diastol</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienDiastole && PasienDiastole > 0">{{ PasienDiastole }}</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 23%">diagnosa sementara</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienDiagnose }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="pl-0" style="width: 23%">Terapi/Obat yang Telah di Lakukan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienTerapiObat }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>

                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span>
                                            {{ RemarksDiagnosa }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <textarea v-model="RemarksDiagnosa" type="text"
                                                        class="w-100 form-control"></textarea>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-12 mt-4">
            <div class="row">
                <div class="col-12">
                    <p>{{ KlinikInformation.KlinikCity }}, {{ SuratDate() }}</p>
                </div>
                <div class="col-12 mt-4 pt-4">
                    <p class="mb-1">{{ DokterInformation.DokterName }}</p>
                    <p>{{ DokterInformation.DokterSIP }}</p>
                </div>
            </div>
        </div>

        <div class="col-12">
            <SuratPenunjangFormBaseDigitalSign />
        </div>
    </div>
</template>

<script>
import "vue2-datepicker/index.css";
import { mapState, mapGetters, mapMutations } from 'vuex'
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

import { SuratDate, SuratDatePickerFormat } from '../../Helpers/DateSurat.js'
import { ParseJenisKelaminSurat } from '../../Helpers/ParseJenisKelaminSurat.js'
import { PekerjaanCustom } from '../../Helpers/PekerjaanSurat.js'

export default {
    name: 'SuratRujukannonBPJSBody',
    components: {
        VMultiSelect: () => import('vue-multiselect'),
        SuratPenunjangFormBaseDigitalSign: () => import('../Base/SuratPenunjangFormBaseDigitalSign.vue')
    },
    data() {
        return {
            TertujuHeader: null,
            TertujuDetail: null,
            PasienName: null,
            PasienAge: null,
            PasienSex: null,
            PasienNIK: null,
            SelectedPekerjaan: null,
            CustomPekerjaan: null,
            PasienAddress: null,
            PasienAnamnesa: null,
            PasienHeight: null,
            PasienWeight: null,
            PasienSystole: null,
            PasienDiastole: null,
            PasienDiagnose: null,
            PasienTerapiObat: null,
            RemarksDiagnosa: null,
        }
    },
    watch: {
        PasienInformation: {
            handler: function (val) {
                if (val && Object.keys(val).length > 0 && !this.LetterID) {
                    Object.keys(val).map(key => {
                        if (this[key] !== undefined) {
                            let tmpVal = val[key]
                            this.$set(this, key, tmpVal)
                        }
                        if (key == 'PasienJob' && this.checkValueData(val[key])) {
                            this.SelectedPekerjaan = val[key];
                            if (this.IsLainLainSelected) this.CustomPekerjaan = val[`${key}Custom`];
                        }
                    })

                    this.$nextTick(() => {
                        this.SetPasienDiagnose()
                    })
                }
            },
            deep: true,
            immediate: true
        },
        TataLaksanaPenunjang: {
            handler: function (val) {
                if (val) {
                    this.$nextTick(() => {
                        this.SetPasienTerapiObat()
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('ComponentMounted')
        })
    },
    computed: {
        ...mapState(['rekamMedis']),
        ...mapState('SuratPenunjangStore', ['CurrentlyPrintingLetter', 'PasienInformation', 'KlinikInformation', 'DokterInformation', 'TransKlinikIDFromPembayaran', 'LetterID', 'TataLaksanaPenunjang', 'AtPembayaranPage', 'LetterNumber']),
        ...mapGetters('SuratPenunjangStore', ['API_URL', 'PekerjaanSurat', 'TransKlinikID']),
        IsLainLainSelected() {
            return this.SelectedPekerjaan === 'Lain-lain'
        },
        SuratRujukanNonBPJSEndpoint() {
            return `${this.API_URL}/surat-rujukan-non-bpjs`
        },
        PayloadBackend() {
            return {
                tertujuHeader: this.TertujuHeader,
                tertujuDetail: this.TertujuDetail,
                namaPasien: this.PasienName,
                umurPasien: this.PasienAge,
                jenisKelaminPasien: this.PasienSex,
                nikPasien: this.PasienNIK,
                pekerjaanPasien: this.IsLainLainSelected ? this.CustomPekerjaan : this.SelectedPekerjaan,
                alamatPasien: this.PasienAddress,
                anamnesaPasien: this.PasienAnamnesa,
                tinggiBadanPasien: this.PasienHeight,
                beratBadanPasien: this.PasienWeight,
                sistolePasien: this.PasienSystole,
                diastolePasien: this.PasienSystole,
                diagnosaSementaraPasien: this.PasienDiagnose,
                obatTindakanPasien: this.PasienTerapiObat,
                keteranganObatTindakanPasien: this.RemarksDiagnosa,
                butaWarna: this.SelectedButaWarna,
                kotaSurat: this.KlinikInformation.KlinikCity,
                tanggalSurat: this.SuratDate(),
                transKlinikId: !this.AtPembayaranPage ? this.TransKlinikID : this.TransKlinikIDFromPembayaran,
                nomorSurat: this.LetterNumber
            }
        }
    },
    methods: {
        ...mapMutations(['SET_LOADING']),
        ...mapMutations('SuratPenunjangStore', ['SetLetterNumber']),
        PekerjaanCustom,
        SuratDatePickerFormat,
        ParseJenisKelaminSurat,
        SuratDate,
        SetPasienDiagnose() {
            let tmpDiagnose = []
            if (this.rekamMedis.postData.kode_penyakit_primary && this.rekamMedis.postData.kode_penyakit_primary.kode) {
                tmpDiagnose.push(this.rekamMedis.postData.kode_penyakit_primary);
            }
            if (this.rekamMedis.postData.kode_penyakit && this.rekamMedis.postData.kode_penyakit.length > 0) {
                this.rekamMedis.postData.kode_penyakit.forEach((item) => {
                    tmpDiagnose.push(item);
                });
            }
            if (this.rekamMedis.postData.odontogram_icdx && this.rekamMedis.postData.odontogram_icdx.length > 0) {
                this.rekamMedis.postData.odontogram_icdx.forEach((item) => {
                    item.forEach(v => {
                        tmpDiagnose.push(v);
                    });
                });
            }
            this.PasienDiagnose = tmpDiagnose.map(item => `${item.description} - ${item.kode}`).join(', ');
        },
        MapPrescriptionAndActions(target = 'obat') {
            if (this.TataLaksanaPenunjang && this.TataLaksanaPenunjang.length > 0) {
                return this.TataLaksanaPenunjang.map(item => {
                    if (item.kategori_layanan && item.kategori_layanan.toLowerCase() === target) {
                        return `${item.nama_layanan} ${item.quantity}`
                    } else {
                        return null
                    }
                }).filter(item => item).join(', ')
            } else if (this.rekamMedis.postData.tatalaksana && this.rekamMedis.postData.tatalaksana.length > 0) {
                return this.rekamMedis.postData.tatalaksana.map(item => {
                    if (item.kategori_layanan && item.kategori_layanan.toLowerCase() === target) {
                        return `${item.nama_layanan} ${item.quantity}`
                    } else {
                        return null
                    }
                }).filter(item => item).join(', ')
            }
        },
        SetPasienTerapiObat() {
            const Obat = this.MapPrescriptionAndActions('obat')
            const Terapi = this.MapPrescriptionAndActions('tindakan')

            if (Obat && Terapi) {
                this.PasienTerapiObat = `${Obat}, ${Terapi}`
            } else if (Obat || Terapi) {
                this.PasienTerapiObat = `${Obat || Terapi}`
            } else {
                this.PasienTerapiObat = null
            }
        },
        async GetData() {
            this.SET_LOADING(true)

            this.$nextTick(async () => {
                const { data } = await this.$axios.get(`${this.SuratRujukanNonBPJSEndpoint}/${this.LetterID}`);

                this.TertujuHeader = data.tertuju_header
                this.TertujuDetail = data.tertuju_detail
                this.PasienName = data.nama_pasien
                this.PasienAge = data.umur_pasien
                this.PasienSex = data.jenis_kelamin_pasien
                this.PasienNIK = data.nik_pasien
                this.SelectedPekerjaan = this.PekerjaanCustom(data.pekerjaan_pasien)
                this.CustomPekerjaan = this.SelectedPekerjaan === 'Lain-lain' ? data.pekerjaan_pasien : null
                this.PasienAddress = data.alamat_pasien
                this.PasienAnamnesa = data.anamnesa_pasien
                this.PasienHeight = data.tinggi_badan_pasien
                this.PasienWeight = data.berat_badan_pasien
                this.PasienSystole = data.sistole_pasien
                this.PasienDiastole = data.diastole_pasien
                this.PasienDiagnose = data.diagnosa_sementara_pasien
                this.PasienTerapiObat = data.obat_tindakan_pasien
                this.RemarksDiagnosa = data.keterangan_obat_tindakan_pasien

                this.SetLetterNumber(data.nomor_surat)

                this.$nextTick(() => {
                    this.SET_LOADING(false)
                })
            })
        },
        async UpdateData() {
            const { data } = await this.$axios.put(`${this.SuratRujukanNonBPJSEndpoint}/${this.LetterID}`, this.PayloadBackend);
            return data;
        },
        async SaveData() {
            const { data } = await this.$axios.post(`${this.SuratRujukanNonBPJSEndpoint}/create`, this.PayloadBackend);
            return data;
        },
    }
}
</script>

<style lang="scss">
.surat-rujukan-non-bpjs {
    .table {
        td {
            padding-top: 0;
            padding-bottom: 14px;
            font-size: 16pt !important;
        }
    }
}

.fs-12 {
    font-size: 16pt !important;
}
</style>